
export const initialValues = {
  roleName: "",
  activeStatus: 1,

}